import { photosApi } from 'src/services/api';
import { uploadFileWithRetry } from 'src/components/order/new/utils/upload-utils';

/**
 * Upload one image for a card design and return its storage key — the
 * `sourceKey` an image layer carries. The same presigned pipeline a customer
 * photo dropped into the editor takes, so the editor preview and the
 * /api/render-card print render resolve it the same way.
 */
export async function uploadCardPhoto(file: File): Promise<string> {
  const resp = await photosApi.photoControllerGetPresignedUrls({
    files: [{ name: file.name, type: file.type }],
  });
  const urlInfo = resp.data.urls?.[0];
  if (!urlInfo?.url || !urlInfo?.headUrl || !urlInfo?.key) {
    throw new Error('Failed to get presigned URL');
  }
  await uploadFileWithRetry(urlInfo.url, urlInfo.headUrl, file);
  return urlInfo.key;
}
